import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`卡珀・古尼亞是一位獨立軟體架構師,講師以及有著製造業 10 年經驗的顧問。他熱衷於將領域驅動設計和其他方法論應用在商業對齊並且讓團隊成功及生產力提升的方式讓軟體得以交付價值。卡珀與客戶一起協作,其地點包含: 星巴克,時代, GFT, Sportradar 和政府機關。在他的空閒時間,他會舉辦倫敦的領域驅動設計 Meepup。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      